import { render, staticRenderFns } from "./moneytransfers.vue?vue&type=template&id=3cb268b6&"
import script from "./moneytransfers.vue?vue&type=script&lang=js&"
export * from "./moneytransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports